import { __t } from '../i18n/t'

/**
 * `required()` do react-admin aceita texto só com espaços ("   " passa). No login isso
 * chegava ao backend como credencial inválida. Mesma mensagem padrão do `required()`.
 */
export const requiredTrim = () => (value: unknown) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '')
    ? 'ra.validation.required'
    : undefined

/**
 * Cadastro de usuário sem rede: o campo Rede só aparece para admin, e o admin sem rede na
 * barra e sem escolher no formulário mandava POST /employees sem chainId ("Rede não definida").
 * `getSelectedChainId` devolve a rede que o provider injetaria (getChainId()); é função para ler a
 * escolha atual da barra na hora de validar, não a do render.
 */
export const validateChainSelected = (getSelectedChainId: () => string | null | undefined) => (values: { chainId?: string | null }) =>
  values?.chainId || getSelectedChainId() ? {} : { chainId: __t('Selecione uma rede') }

/**
 * Latitude/longitude fora da faixa quase sempre é separador decimal perdido: "-19,92" no campo
 * numérico chega como -1992. Em 04/11/2026 havia 72 cadastros (5 postos, 67 parceiros) com
 * coordenada impossível, um criado no mesmo dia com -1824 / -4360, e o mapa e a distância no app
 * ficam errados sem aviso.
 * Vazio passa: obrigatoriedade é com `required()` (pedido ao dev #10).
 */
const coordinateInRange = (limit: number) => (value: unknown) => {
  if (value === null || value === undefined || value === '') return undefined
  const n = Number(value)
  return Number.isFinite(n) && Math.abs(n) <= limit
    ? undefined
    : __t('Use um valor entre -%{limite} e %{limite}, com ponto decimal (ex.: -19.9245)', { limite: limit })
}

export const validateLatitude = coordinateInRange(90)
export const validateLongitude = coordinateInRange(180)
